import { render, staticRenderFns } from "./VehicleAmenities.vue?vue&type=template&id=16f4b5c2&scoped=true&"
import script from "./VehicleAmenities.vue?vue&type=script&lang=js&"
export * from "./VehicleAmenities.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAmenities.vue?vue&type=style&index=0&id=16f4b5c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4b5c2",
  null
  
)

export default component.exports